





import { Component, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'

// 该页面是跳转页，临时解决方案，用于跳转到老系统
// 获取当前域名跳转到对应的播控页
const getHost = () => {
  let prd = ''
  const hostName = location.hostname
  if (hostName.indexOf('futureclass') > -1) {
    prd = 'https://futureclass.growlib.com'
  } else {
    prd = 'https://xr.growlib.com'
  }
  return prd
}

const classroomPrefixMap = {
  dev: 'http://localhost:9999',
  prd: getHost(),
}

@Component
export default class ClassJump extends ViewBase {
  /** 课程 id */
  @Prop({ type: Number, default: 0 }) id!: number

  /** 资源 id */
  @Prop({ type: Number, default: 0 }) resourceId!: number

  created() {
    // 这里的逻辑是，若明确存在 resourceId，则直接使用 resourceId
    // 否则，若存在 id，则取课程的第一个 resource 作为 resoureId
    // 最后，若都不存在，则取 store 中的 playList 中的第一项

    const { id, resourceId } = this as any

    if (resourceId > 0) {
      return this.goClassroom(resourceId)
    }

    if (id > 0) {
      // TODO: 处理播放课程的情况
    }

    const playList = this.$store.state.playList || []
    const firstId = playList.length > 0 ? playList[0].id : 0
    this.goClassroom(firstId)
  }

  goClassroom(resId: number) {
    const prefix = classroomPrefixMap[VAR.env]
    location.replace(`${prefix}/classroom/${resId}`)
  }
}
